import styled,{keyframes} from "styled-components";
import React, { useEffect, useState } from "react";
import { convert_personality_to_categories } from "utilities/structureUtils";
import { all } from "redux-saga/effects";
import { stripMarkdownAndHtml } from "utilities/stripMarkdown";



const ItemRow = ({ data, isExpanded, summary, min, max, verticalTitles, findByOptionName }) => {
    const [questionData, setQuestionData] = useState([]);

    const formatScoreDisplay = (score) => {
        if (score === null || score === undefined || isNaN(score) || score === 'NaN' || score === '') {
          return '-';
        }
        return score;
    };

    const getColorGrade = (score) => {
        if (
            score === null ||
            score === undefined ||
            isNaN(score) ||
            score === "" ||
            score === "NaN"
        ) {
            return "#fff";
        }

        // Convert score to number if it's a string
        const numericScore = typeof score === "string" ? parseFloat(score) : score;

        // Double check after conversion
        if (isNaN(numericScore)) {
            return "#fff";
        }

        // Discrete color ranges - Red: 0-4.9, Yellow: 5-6.9, Green: 7-10
        if (numericScore >= 0 && numericScore < 5) {
            return "#dd524c"; // Red
        } else if (numericScore >= 5 && numericScore < 7) {
            return "#f5d565"; // Yellow
        } else if (numericScore >= 7 && numericScore <= 10) {
            return "#10B981"; // Green
        }

        return "#fff";
    }

    const getTextColor = (score) => {
        // Yellow text should use #6f391a
        if (
            score === null ||
            score === undefined ||
            isNaN(score) ||
            score === "" ||
            score === "NaN"
        ) {
            return "#000";
        }

        const numericScore = typeof score === "string" ? parseFloat(score) : score;

        if (isNaN(numericScore)) {
            return "#000";
        }

        // Yellow cells (5-6.9) should have #6f391a text color
        if (numericScore >= 5 && numericScore < 7) {
            return "#6f391a";
        }

        return "#fff";
    }

      useEffect(()=>{
            if(data){
                let questions = Object.values(data[0].outcome_scores.question_scores).filter(i=>i.outcome == summary.name)
                setQuestionData(questions)
            }
      },[data, summary])


      const get_item_scores = (question) => {
          let counted_responses = 0;
          let all_scores = 0;
        data.forEach((item)=>{
            let score = Object.values(item.outcome_scores.question_scores).find(i => i.question == question)?.scores;
            let responses = item.responses || 0;
            if(score !== null && score !== undefined && !isNaN(score)){
                counted_responses += responses;
                all_scores += score * responses;
            }
        });

          if (counted_responses === 0) return null;
          const avg = all_scores / counted_responses;
          return isNaN(avg) ? null : avg.toFixed(1);
      }

    return (

        <>

        {isExpanded && (
                <>
                {questionData.map((question, idx) => {
                    const overall_score = get_item_scores(question.question);
                   return (
                    <TableRow2 key={question.question || idx} selected={isExpanded}>
                           <FirstColumnCell3>{stripMarkdownAndHtml(question.question)}</FirstColumnCell3>
                           <TableCell color={getColorGrade(overall_score)} textColor={getTextColor(overall_score)}>{formatScoreDisplay(overall_score)}</TableCell>
                        
                           {verticalTitles.map((title) => {
                               const item = findByOptionName(title);
                               if (!item) {
                                   return (
                                       <TableCell
                                           key={`${title}-${question.question}`}
                                           color="#fff"
                                           textColor="#000"
                                       >
                                           -
                                       </TableCell>
                                   );
                               }
                               const meetsThreshold = item?.meetsThreshold !== false; // Default to true if not set

                               if (!meetsThreshold) {
                                   return (
                                       <TableCell
                                           key={`${title}-${question.question}`}
                                           color="#fff"
                                           textColor="#000"
                                       >
                                           -
                                       </TableCell>
                                   );
                               }

                               let rawScore = Object.values(item?.outcome_scores?.question_scores || {}).find(i => i.question == question.question)?.scores;
                            let score = rawScore !== null && rawScore !== undefined && !isNaN(rawScore) ? rawScore.toFixed(1) : null;
                            return (
                                <TableCell
                                    key={`${title}-${question.question}`}
                                    color={getColorGrade(score)}
                                    textColor={getTextColor(score)}
                                >
                                    {formatScoreDisplay(score)}
                                </TableCell>
                            );
                        })}
                    </TableRow2>
                )}  
                )}


                </>

        )}

        </>
    )

}

export default ItemRow;


const TableRow2 = styled.tr`
    max-height:${props=>props.selected ? '200px' : '0px'};
    height: ${props=>props.selected ? '35px' : '0px'};
    overflow:hidden;
    transition:all 0.8s;
`;



const TableCell = styled.td`
  border: 1px solid #ddd;
  padding: 0;
  text-align: center;
  width: 50px;
  height:100%;
  font-weight: 500;

  background-color: ${props => props.color ? props.color : '#fff'};
  color: ${props => props.textColor || '#000'};

`;


const FirstColumnCell2 = styled.td`
  border: 1px solid #ddd;
  padding: 0 16px;
  text-align: left;
  width: 350px; /* Wider first column */
  min-width: 350px;
  height: 100%;
  background-color: #fff;
  color: #2A3039;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  position: sticky;
  left: 0;
  z-index: 1;
`;

const FirstColumnCell3 = styled.td`
  border: 1px solid #ddd;
  padding: 5px 24px;
  text-align: left;
  width: 350px; /* Wider first column */
  min-width: 350px;
  height: 100%;
  background-color: #fff;
  color: #2A3039;
  font-size: 12px;
  cursor: pointer;
  position: sticky;
  left: 0;
  z-index: 1;
`;


const QuestionData = [
    {
        question: 'We help and support one another through emotional hardships (e.g. tough times).We help and support one another through emotional hardships (e.g. tough times).',
        overall: 76,
        customerService: 4,
        sales: -3,
        marketing: -6,
        operations: -16,
    },
    {
        question: 'How do you feel about the customer service?',
        overall: 77,
        customerService: 5,
        sales: -2,
        marketing: -5,
        operations: -15,
    },
    {
        question: 'How do you feel about the sales team?',
        overall: 78,
        customerService: 6,
        sales: -1,
        marketing: -4,
        operations: -14,
    }
]